// Show/hide buttons store their targets as the element's DOM class, "id-<node id>"
// (PageTree.getDomNodeId). Buttons built through the pages API (PML) before ENG-8181
// stored the bare node id, so clicking them matched nothing. Accept both forms.
export function showHideTargetClass(id: string): string {
  const trimmed = id.trim()
  return trimmed.startsWith('id-') ? trimmed : `id-${trimmed}`
}
